import script from "./ResultsNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultsNavigation.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__